module.exports = __webpack_public_path__ + "media/images/parallax/illustration-connect-foreground-0a4f8063e6b4548439ac5248ee2562f0.png";